import React from "react"
import dayjs from "dayjs"

import { RichText } from "components"

function Content({ post }) {
  if (post?.content)
    return (
      <section className="pt-18 wrapper default-grid md:pt-14">
        {post?.date && (
          <div className="col-span-full text-darkNavy">
            <p className="cap-subtitle">
              {dayjs(post?.date).format("MMM DD, YYYY")}
            </p>
          </div>
        )}
        <RichText
          className="col-span-full lg:col-span-8"
          content={post?.content}
          size="large"
        />
      </section>
    )
  else return null
}

export default Content
